import React, { useState } from 'react'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip as MuiTooltip,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import LoadingSpinner from 'components/loading-spinner'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  noData: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  titleMargin: {
    marginBottom: theme.spacing(3),
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  title: {
    flex: 1,
  },
  tableContainer: {
    maxHeight: 300,
    overflow: 'auto',
  },
  table: {
    minWidth: 300,
  },
  tableHead: {
    backgroundColor: '#f5f5f5',
  },
  tableHeadCell: {
    fontWeight: 600,
    color: '#00205B',
    fontSize: '0.875rem',
  },
  tableBodyCell: {
    fontSize: '0.875rem',
  },
  titleCell: {
    fontWeight: 500,
    color: '#333',
  },
  numberCell: {
    fontWeight: 600,
    color: '#00205B',
    textAlign: 'right',
  },
  earningsCell: {
    fontWeight: 600,
    color: '#00205B',
    textAlign: 'right',
  },
}))

const TopGroupEventsChart = ({ data, loading, error, tooltip }) => {
  const classes = useStyles()
  const [showTooltip, setShowTooltip] = useState(false)

  const renderContent = () => {
    if (loading) return <LoadingSpinner />
    if (error) {
      return <Box className={classes.noData}>Error loading chart data</Box>
    }
    if (!data?.length) return <Box p={3}>No group event data available</Box>

    return (
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} stickyHeader>
          <TableHead>
            <TableRow className={classes.tableHead}>
              <TableCell className={classes.tableHeadCell}>
                Event Title
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="right">
                Registrations
              </TableCell>
              <TableCell className={classes.tableHeadCell} align="right">
                Revenue
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index} hover>
                <TableCell
                  className={`${classes.tableBodyCell} ${classes.titleCell}`}
                >
                  {item.groupEvent.title}
                </TableCell>
                <TableCell
                  className={`${classes.tableBodyCell} ${classes.numberCell}`}
                >
                  {item.registrationCount.toLocaleString()}
                </TableCell>
                <TableCell
                  className={`${classes.tableBodyCell} ${classes.earningsCell}`}
                >
                  ${item.earnings.toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  return (
    <Box
      className={classes.root}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onFocus={() => setShowTooltip(true)}
      onBlur={() => setShowTooltip(false)}
      style={{ position: 'relative' }}
    >
      <Typography variant="h6" className={classes.titleMargin}>
        Top Group Events
      </Typography>
      {tooltip && showTooltip && (
        <Box
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            zIndex: 1,
          }}
        >
          <MuiTooltip title={tooltip} placement="top">
            <InfoOutlinedIcon
              style={{ fontSize: 18, color: '#666', cursor: 'help' }}
            />
          </MuiTooltip>
        </Box>
      )}
      {renderContent()}
    </Box>
  )
}

export default TopGroupEventsChart
